import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import store from '../store'
import Loading from '../views/Loading'
import Landing from '../views/Landing'
import Home from '../views/Home'
import Solutions from '../views/Solutions'
import Services from '../views/Services'
import Company from '../views/Company'
import GreenSpirit from '../views/GreenSpirit'
import Contacts from '../views/Contacts'
import InfoContact from '../views/Contacts/InfoContact'
import JobContact from '../views/Contacts/JobContact'
import FormError from '../views/Contacts/FormError'
import FormSuccess from '../views/Contacts/FormSuccess'
import Articles from '../views/Articles'
import Cookie from '../views/Cookie'
import Privacy from '../views/Privacy'
import RossettoMenu from '../views/RossettoMenu'
import NotFound from '../views/NotFound'
// import Courtesy from '../views/Courtesy'

import routesList from './routesList'
import _ from 'lodash'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    // store position
    const oldPosition = store.getters['animations/oldRoutePosition']
    const oldName = store.getters['animations/oldRouteName']
    if (oldName === to.name && typeof oldPosition !== 'undefined') {
      store.commit('animations/updateOldRoutePosition', undefined)
      return { x: 0, y: oldPosition }
    }

    if (savedPosition) return savedPosition
    if (_.includes(from.name, 'contacts') && _.includes(to.name, 'contacts')) return { selector: '.contacts__form' }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'loading',
      component: Loading,
      meta: {
        position: routesList.loading.position,
        seo: {
          title: 'Pololab',
          description: 'description'
        }
      }
    },
    /* {
      path: '/',
      name: 'courtesy',
      component: Courtesy
    }, */
    {
      path: '/home/',
      name: 'landing',
      component: Landing,
      pathToRegexpOptions: { strict: true },
      meta: {
        position: routesList.landing.position,
        seo: {
          title: 'Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/laboratorio/',
      name: 'home',
      component: Home,
      pathToRegexpOptions: { strict: true },
      meta: {
        position: routesList.home.position,
        seo: {
          title: 'Il laboratorio - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/soluzioni/',
      name: 'solutions',
      component: Solutions,
      pathToRegexpOptions: { strict: true },
      meta: {
        position: routesList.solutions.position,
        seo: {
          title: 'Soluzioni - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/soluzioni/:slug/',
      name: 'article',
      component: Articles,
      pathToRegexpOptions: { strict: true },
      meta: {
        seo: {
          title: 'Articolo - Pololab',
          description: 'description'
        }
      },
      props: route => ({
        slug: route.params.slug
      })
    },
    {
      path: '/servizi/',
      name: 'services',
      component: Services,
      pathToRegexpOptions: { strict: true },
      meta: {
        position: routesList.services.position,
        seo: {
          title: 'Servizi - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/ricerca-e-sviluppo/',
      name: 'company',
      component: Company,
      pathToRegexpOptions: { strict: true },
      meta: {
        position: routesList.company.position,
        seo: {
          title: 'Ricerca e Sviluppo - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/sistema-di-qualita/',
      name: 'greenSpirit',
      component: GreenSpirit,
      pathToRegexpOptions: { strict: true },
      meta: {
        position: routesList.greenSpirit.position,
        seo: {
          title: 'Sistema di qualità - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/contatti/',
      component: Contacts,
      pathToRegexpOptions: { strict: true },
      children: [
        {
          path: '',
          component: InfoContact,
          pathToRegexpOptions: { strict: true },
          name: 'info-contacts',
          meta: {
            seo: {
              title: 'Contatti - Pololab',
              description: 'description'
            }
          }
        },
        {
          path: 'lavora-con-noi/',
          component: JobContact,
          pathToRegexpOptions: { strict: true },
          name: 'job-contacts',
          meta: {
            seo: {
              title: 'Contatti - Pololab',
              description: 'description'
            }
          }
        },
        {
          path: 'inviato/',
          component: FormSuccess,
          pathToRegexpOptions: { strict: true },
          name: 'form-success',
          meta: {
            seo: {
              title: 'Contatto Inviato - Pololab',
              description: 'description'
            }
          }
        },
        {
          path: 'errore/',
          component: FormError,
          pathToRegexpOptions: { strict: true },
          name: 'form-error',
          meta: {
            seo: {
              title: 'Errore Contatti - Pololab',
              description: 'description'
            }
          }
        }
      ]
    },
    {
      path: '/privacy-policy/',
      name: 'privacy',
      component: Privacy,
      pathToRegexpOptions: { strict: true },
      meta: {
        seo: {
          title: 'Privacy Policy - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/cookie-policy/',
      name: 'cookie',
      component: Cookie,
      pathToRegexpOptions: { strict: true },
      meta: {
        seo: {
          title: 'Cookie Policy - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '/menu/',
      name: 'menu',
      component: RossettoMenu,
      pathToRegexpOptions: { strict: true },
      meta: {
        seo: {
          title: 'Menu - Pololab',
          description: 'description'
        }
      }
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
      meta: {
        seo: {
          title: 'Pagina non trovata - Pololab',
          description: 'description'
        }
      }
    }
  ]
})

Vue.use(VueAnalytics, {
  id: 'UA-125679695-1',
  beforeFirstHit () {
    Vue.$ga.set('anonymizeIp', true)
  },
  router
})

const storedScrollRoutes = [
  'contacts',
  'info-contacts',
  'tech-contacts',
  'job-contacts',
  'menu'
]

const waitForScroll = (to, from, position = 0) => {
  return new Promise((resolve, reject) => {
    // stored scroll way
    if (storedScrollRoutes.includes(to.name)) {
      const currentPosition = store.getters['animations/windowScrollPosition']
      store.commit('animations/updateOldRoutePosition', currentPosition)
      store.commit('animations/updateOldRouteName', from.name)
      return resolve()
    }

    // we already scrolled
    if (window.pageYOffset === position) return resolve()

    // attach action
    window.addEventListener('scroll', scrollAction.bind(undefined, position, resolve))

    // start scrolling
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })
}

const scrollAction = (position, resolve) => { if (window.pageYOffset === position) resolve() }

router.beforeEach(async (from, to, next) => {
  await waitForScroll(from, to)

  // cleanup
  window.removeEventListener('scroll', scrollAction)
  next()
})

router.beforeResolve((to, from, next) => {
  document.title = to.meta.seo.title
  document.head.querySelector('meta[name="description"]').setAttribute('content', to.meta.seo.description)
  document.head.querySelector('link[rel="canonical"]').setAttribute('href', window.location.origin + _.trimEnd(to.path, '/'))
  next()
})

export default router
